import { render, staticRenderFns } from "./Dialer.vue?vue&type=template&id=ff277218&scoped=true&lang=pug&"
import script from "./Dialer.vue?vue&type=script&lang=js&"
export * from "./Dialer.vue?vue&type=script&lang=js&"
import style0 from "./Dialer.vue?vue&type=style&index=0&id=ff277218&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff277218",
  null
  
)

export default component.exports